import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

console.log("index.js executing...");
const rootEl = document.getElementById("root");
console.log("root element:", rootEl);
console.log("ReactDOM:", typeof ReactDOM);
console.log("ReactDOM.createRoot:", typeof ReactDOM.createRoot);

const root = ReactDOM.createRoot(rootEl);
console.log("root created:", root);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
console.log("render called");
